export const CircularAddIcon = props => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.33325 7.33301V4.66634H8.66659V7.33301H11.3333V8.66634H8.66659V11.333H7.33325V8.66634H4.66659V7.33301H7.33325ZM7.99992 14.6663C4.31802 14.6663 1.33325 11.6815 1.33325 7.99967C1.33325 4.31777 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31777 14.6666 7.99967C14.6666 11.6815 11.6818 14.6663 7.99992 14.6663ZM7.99992 13.333C10.9455 13.333 13.3333 10.9452 13.3333 7.99967C13.3333 5.05415 10.9455 2.66634 7.99992 2.66634C5.0544 2.66634 2.66659 5.05415 2.66659 7.99967C2.66659 10.9452 5.0544 13.333 7.99992 13.333Z'
      fill='#4361EE'
    />
  </svg>
);
